import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import useThrottledWindowScrollPosition from 'hooks/useThrottledWindowScrollPosition';
const useProductListingTrackScrollPosition = t0 => {
  const $ = _c(11);
  const {
    hasScrollPositionBeenRestored,
    lastProductPath,
    loadMoreClickCount,
    previousScrollPosition,
    setScrollDataInSessionStorage,
    isScrollTrackingDisabled: t1
  } = t0;
  const isScrollTrackingDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== hasScrollPositionBeenRestored || $[1] !== isScrollTrackingDisabled || $[2] !== lastProductPath || $[3] !== loadMoreClickCount || $[4] !== previousScrollPosition || $[5] !== setScrollDataInSessionStorage) {
    t2 = updatedScrollPosition => {
      if (!isScrollTrackingDisabled && hasScrollPositionBeenRestored && previousScrollPosition !== updatedScrollPosition) {
        setScrollDataInSessionStorage(prevData => ({
          ...prevData,
          lastProductPath,
          loadMoreClickCount,
          scrollPosition: updatedScrollPosition
        }));
      }
    };
    $[0] = hasScrollPositionBeenRestored;
    $[1] = isScrollTrackingDisabled;
    $[2] = lastProductPath;
    $[3] = loadMoreClickCount;
    $[4] = previousScrollPosition;
    $[5] = setScrollDataInSessionStorage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const onWindowScrollCallback = t2;
  let t3;
  if ($[7] !== isScrollTrackingDisabled || $[8] !== onWindowScrollCallback || $[9] !== previousScrollPosition) {
    t3 = {
      callback: onWindowScrollCallback,
      time: 1000,
      isScrollTrackingDisabled,
      previousScrollPosition
    };
    $[7] = isScrollTrackingDisabled;
    $[8] = onWindowScrollCallback;
    $[9] = previousScrollPosition;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useThrottledWindowScrollPosition(t3);
};
export default useProductListingTrackScrollPosition;